module.exports = __webpack_public_path__ + "img/16_128.e1d06b41.png";